import { connect } from 'react-redux'

import PositionsPane from '../components/PositionsPane'
import { RootState } from '../types'
import { TradingAction, togglePositions, closeAllTrades, selectPosition } from '../actions'
import { setModal } from '../actions/dialogActions'
import { I18n } from 'react-redux-i18n'
import { MT4Connector } from '@bdswiss/mt4-connector'
import { Dispatch } from 'redux'

const mt4 = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  return {
    opened: state.positionsOpened,
    positionsCount: mt4.positions.size,
    accountLoaded: state.accountLoaded,
    tradeOperationEnabled: rootState.tradingPane.tradeOperationEnabled,
    appMode: state.appMode,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onCloseAllTrades: () =>
      dispatch(
        setModal(I18n.t(`closingPositions`), I18n.t('closeAllPositionsMessage'), closeAllTrades())
      ),
    onToggleMenu: () => dispatch(togglePositions()),
    onSelectPosition: (order: number, expanded?: boolean) =>
      dispatch(selectPosition(order, expanded)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PositionsPane)
